import { Box, Link, Typography } from '@mui/material';
import { FC, ReactNode } from 'react';

import RefreshButton, { ButtonType } from './RefreshButton';

export const errors = {
  noInstance: () => (
    <Typography variant="body2">
      Failed to connect to Received Connect. See{' '}
      <Link
        sx={{ color: 'inherit', textDecoration: 'underline' }}
        href="https://receiveddigital.com/help-center/admin/troubleshooting-received-connect/"
        target="_blank"
        rel="noopener noreferrer"
      >
        troubleshooting steps here.
      </Link>
    </Typography>
  ),
  noPrinter: () => 'No printers found',
  offline: (name: string) => () => <span>{name} is offline</span>,
};

type Props = {
  isLoading: boolean;
  children: ReactNode;
  onClick: () => void;
  textColor?: string;
  type?: ButtonType;
};

const RefreshError: FC<Props> = ({ type = 'refresh', isLoading, children, onClick }) => (
  <>
    <Box sx={{ textAlign: 'left' }}>
      <Typography variant="body2" sx={{ mx: 1, my: 2 }}>
        {children}
      </Typography>
    </Box>
    <RefreshButton type={type} onClick={onClick} isLoading={isLoading} />
  </>
);

export default RefreshError;
